/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'

var swiper = new Swiper('.home-slider-swiper', {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 320px
        1400: {
          slidesPerView: 3
        },
        900: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        1: {
          slidesPerView: 1,
        }
    }
/*       navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }, */
});


/* ============ */ 

var swiper = new Swiper('.swiper-carousel-reviews', {
slidesPerView: 'auto',
spaceBetween: 120,
centeredSlides: true,
loop: true,

pagination: {
  el: '.swiper-scrollbar',
  hide: true,
  clickable: true
}
});

/* ========== */

var swiper = new Swiper('.swiper-last', {
// slidesPerView: 'auto',
// spaceBetween: 20,
// centeredSlides: true,
loop: true,
speed: 1500,
autoplay: {
  delay: 3000,
},
pagination: {
  clickable: true
}
});

/* ========== */
var swiper = new Swiper('.swiper-carousel-reviews-one', {
slidesPerView: 'auto',
spaceBetween: 100,
centeredSlides: true,
loop: true,

pagination: {
  el: '.swiper-scrollbar',
  hide: true,
  clickable: true
}
});
/* eslint-enable no-console */
